import React from 'react';
import BodyClassName from 'react-body-classname';
import { ThemeProvider, createTheme } from '@mui/material';
import Box from '@mui/material/Box';

import DefaultLayoutComponent from '../../layouts/DefaultLayoutComponent';
import Sidebar from './sidebar';
import TimelineHeader from './TimelineHeader';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FECB04',
    },
    background: {
      paper: '#0A0A0A',
    },
    text: {
      primary: '#ffffff',
      secondary: '#FECB04',
    },
    action: {
      active: '#FECB04',
    },
  },
  typography: {
    fontFamily: `Lato`,
  },
});

const TimeLineLayout = ({ activeItem, seo, children, isForTimelineGraph, sidebarHide }) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  // handle sidebar close and open
  const handleSidebarButton = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <TimelineHeader seo={seo} isForTimelineGraph={isForTimelineGraph}>
      <ThemeProvider theme={theme}>
        <Box
          component="div"
          sx={{
            bgcolor: 'background.paper',
            maxWidth: '100%',
            minHeight: '90vh',
            margin: '0 auto',
            display: 'flex',
            marginTop: '80px',
            flexDirection: { xs: 'column', md: 'row' },
            // paddingLeft: { xs: 0, xl: isForTimelineGraph ? (sidebarOpen ? '176px' : 0) : 0 },
          }}
        >
          {!sidebarHide && (
            <Sidebar activeItem={activeItem} handleSidebarButton={handleSidebarButton} sidebarOpen={sidebarOpen} />
          )}
          <Box
            sx={{
              flex: 1,
              maxWidth: {
                xs: '100%',
                md: sidebarOpen ? 'calc(100% - 270px)' : isForTimelineGraph ? 'calc(100% - 50px)' : '100%',
              },
            }}
          >
            {children}
          </Box>
        </Box>
      </ThemeProvider>
    </TimelineHeader>
  );
};

export default TimeLineLayout;
